import config from "./config";
import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { UserContextProvider } from "@ipd/js-common";
import { ApolloProvider } from "@apollo/client";
import { useAppApolloClient } from "./apollo";
import Permission from "./components/Modals/Permission";
import { AppContext } from "./context";
import App from "./components/App/App";
import * as serviceWorker from "./serviceWorker";
import "./index.css";
import initHeapAnalytics from "./utils/heapScript";

initHeapAnalytics({ APP_ENV: config.APP_ENV ?? "" });
ReactDOM.render(
  <StrictMode>
    <UserContextProvider appName="LciClinicalPipeline" scopes={["AppHeader", "CountrySelectionBar"]}>
      <ApolloProvider client={useAppApolloClient()}>
        <Router>
          <AppContext>
            <Permission>
              <App />
            </Permission>
          </AppContext>
        </Router>
      </ApolloProvider>
    </UserContextProvider>
  </StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
